import ComponentMap from "./component-map"
import Slugify from "slugify"

const PageSectionRow = (props) => {
  const sections = props.content.section_content
  const sluggedName = Slugify(props.content.name, { lower: true })
  const sectionClass = props.content.className ? props.content.className : ""

  return (
    <section
      id={sluggedName}
      className={`fdc-${props.content.contentful_id} page-section__${sluggedName} section section--page-section block__${sections.length}-column ${sectionClass}`}
    >
      <div className="row">
        {sections.map((content, index) => {
          const Cname = content.template ? ComponentMap[content.template] : ComponentMap[content.__typename]

          return <Cname key={content.contentful_id} content={content} index={index} />
        })}
      </div>
    </section>
  )
}

export default PageSectionRow
